// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/employees/{employeeId}/id-cards",
  Create: "/pyr/employees/{employeeId}/id-cards",
  Update: "/pyr/employees/{employeeId}/id-cards",
  Detail: "/pyr/employees/{employeeId}/id-cards",
};
